<template>
  <fieldset>
    <SignupLegend title="Invite users. Pay only when they use their cards."/>
    <p>Invite all the people in your organisation, you would like to have an aio* card.
      For every signed up user, we will send out a new aio* card. <strong>Please note:</strong> You can invite
      additional users later
      through the app.</p>
    <div class="form-group row" v-for="(invitation, i) in invitations" :key="i">
      <label class="col-sm-3 col-form-label">{{nth(i)}} user to invite</label>
      <div class="col-sm-9">
        <input type="email" class="form-control" @keyup="updateInvitations" placeholder="email" ref="invitation"
               :required="invitation.value" v-model="formData.invitations[i]">
        <div class="invalid-feedback">Valid email address is required.</div>
      </div>
    </div>
    <hr>
    <div class="row align-items-center feature-box">
      <div class="col text-center">
        <p><strong>£5</strong> per active user per month
          <span id="cardInfo"><span class="info popup fas fa-info-circle"></span>
              <b-popover target="cardInfo" placement="bottom" triggers="hover focus">
                Active user = user, who spends money with their card during a billing period.
              </b-popover>
            </span>
        </p>
        <p>+ 1.72% charge on float loads</p>
      </div>
      <div class="col">
        <img src="@/assets/aio-card.png" class="img-fluid" alt="aio* card">
      </div>
    </div>
    <hr>
    <p>We require your payment details in order to issue your aio* cards.<br> But you won't be charged until the first usage.</p>
    <div class="form-group row">
      <label class="col-sm-3 col-form-label">Credit or debit card</label>
      <div class="col-sm-9">
        <div id="card-element" class="form-control" ref="cardElement"></div>
        <div class="invalid-feedback">{{stripeFeedback}}</div>
      </div>
    </div>
    <hr>
    <BaseNaviButtons :beforeSubmit="createStripeToken" :toSubmit="formData">
      <slot slot="next" v-if="editedUserInputs() > 0"><span class="far fa-envelope"></span> Invite users</slot>
      <slot slot="next" v-else><span class="far fa-credit-card"></span> Complete</slot>
    </BaseNaviButtons>
  </fieldset>
</template>

<script>
  import BaseNaviButtons from '@/components/BaseNaviButtons'
  import EventBus from '@/utils/EventBus'
  import helperMixin from '@/utils/helperMixin'
  import SignupLegend from '@/components/SignupLegend'

  export default {
    components: {
      BaseNaviButtons,
      SignupLegend
    },
    data () {
      return {
        invitations: this.formData.invitations.length + 1,
        stripeFeedback: ''
      }
    },
    methods: {
      createStripeToken () {
        EventBus.$emit('ajax-start')
        const stripeInput = this.$refs.cardElement.querySelector('input')
        this.stripeFeedback = ''
        return this.stripe.createToken(this.card).then(result => {
          if (result.error) {
            stripeInput.setCustomValidity(result.error.message)
            this.stripeFeedback = result.error.message
          } else {
            stripeInput.setCustomValidity('')
            this.formData.stripeToken = result.token.id
            this.formData.isComplete = true
          }
          EventBus.$emit('ajax-stop')
        })
      },
      editedUserInputs () {
        return this.$refs.invitation ? this.$refs.invitation.filter(i => i.value).length : 0
      },
      updateInvitations () {
        this.invitations = this.editedUserInputs() + 1
      }
    },
    mixins: [helperMixin],
    mounted () {
      this.stripe = window.Stripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY)
      const elements = this.stripe.elements()
      const style = {
        base: {
          color: '#495057',
          lineHeight: '24px',
          fontFamily: 'Rubik, sans-serif',
          fontWeight: 400,
          fontSize: '16px',
          '::placeholder': {
            color: '#6c757d'
          }
        },
        invalid: {
          color: '#EE0156',
          iconColor: '#EE0156'
        }
      }
      this.card = elements.create('card', {style: style})
      this.card.mount('#card-element')
    },
    props: {
      formData: Object
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/sass/variables.scss';

  .feature-box {
    font-size: 19px;

    img {
      max-height: 190px;
    }

    strong {
      font-size: 26px;
    }
  }

  .StripeElement--focus {
    border-color: #80bdff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, .25);
    outline: 0;

    &.StripeElement--invalid {
      box-shadow: 0 0 0 0.2rem rgba(220,53,69,.25);
    }

    &.StripeElement--complete {
      box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, .25);
    }
  }

  .StripeElement--invalid {
    border-color: $el-salmon;

    ~.invalid-feedback {
      display: block;
    }
  }

  .StripeElement--complete {
    border-color: #28a745;
  }
</style>
